import { useTranslation } from '@crehana/i18n';

import type { TKeys } from '../i18n/types';

export function useCourseDetailTranslation() {
  return useTranslation<TKeys>();
}
